import { render } from "./ScoreCards.vue?vue&type=template&id=bd4a4726&scoped=true"
import script from "./ScoreCards.vue?vue&type=script&lang=js"
export * from "./ScoreCards.vue?vue&type=script&lang=js"

import "./ScoreCards.vue?vue&type=style&index=0&id=bd4a4726&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4a4726"]])

export default __exports__